import React from 'react'

function BottomSection() {
    return (
        <React.Fragment>
            <div className="empty-sect"></div>
        </React.Fragment>
    )
}

export default BottomSection
